import styled from "styled-components";
import { Modal } from "components/Modal";

export const ChangePasswordModalContainer = styled(Modal)`
  .modal-content {
    width: 500px !important;
    max-width: 90vw;
  }

  .change-password-form {
    .form-description {
      color: ${({ theme }) => theme.card.font.secondary};
      font-size: 14px;
      margin-bottom: 24px;
      line-height: 1.4;
    }

    .form-control.input-form-field {
      border: 1px solid ${({ theme }) => theme.card.border.quaternary};
      background: ${({ theme }) => theme.toast.bg.primary} !important;
    }

    .security-password-input {
      input {
        margin-bottom: 20px;
      }

      label {
        margin-bottom: 7px;
        font-weight: 500;
        color: ${({ theme }) => theme.card.font.tertiary};
      }
    }

    .form-error {
      color: ${({ theme }) => theme.global.color.error};
      font-size: 12px;
      margin-top: -15px;
      margin-bottom: 15px;
    }

    .modal-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 24px;
      padding-top: 20px;
      border-top: 1px solid ${({ theme }) => theme.card.border.quaternary};

      .cancel-btn {
        padding: 10px 16px;
      }

      .submit-btn {
        padding: 10px 16px;
      }

      button.button-small {
        &:disabled {
          border: 1px solid ${({ theme }) => theme.aside.icon.tertiary};
        }
      }
    }
  }

  .modal-header {
    .body-heading {
      font-weight: 600;
      font-size: 18px;
      color: ${({ theme }) => theme.card.font.tertiary};
    }
  }
`;
